import React from 'react'
import { CarouselItem } from './carousel-item'
import { LeftContent } from './left-content'
import { CallTollFree } from './call-toll-free'
import { RightContent } from './right-content'

export const LabHero = () => {
  return (
    <CarouselItem>
      <LeftContent
        description="Easy tests results integration and association to milk pickups from Lab to Plant."
        title="Laboratory and Plant Integration"
      >
        <CallTollFree />
      </LeftContent>

      <RightContent url="lab/lab.png" alt="lab web application" />
    </CarouselItem>
  )
}
